import { Icon, PopoverInteractionKind, Tooltip } from '@blueprintjs/core'
import CX from 'classnames'
import React from 'react'
import ListingStates from '../constants/listings/ListingStates'
import ListingErrors from './ListingErrors'

interface Props {
  value: string
  errors?: any
  large?: boolean
  message?: any
  customClassName?: string
}

const NiceListingStatus: React.FC<Props> = ({ value, errors, large, message = null, customClassName = '' }) => {
  if (!value) return null
  const stateInfo = ListingStates[value]
  const title = stateInfo && stateInfo.humanReadableName
  let className = stateInfo && stateInfo.tagClassName

  if (customClassName) {
    className = customClassName
  }
  let errorsHumanReadable = errors

  if (errors?.domain?.includes('MARKETPLACE')) {
    errorsHumanReadable = `${errors.longMessage}`
  }

  if (errors?.domain === 'MICROSERVICE_ERROR') {
    if (errors?.category === 'PARAM_MISSING' || errors?.category === 'PARAM_WRONG_FORMAT')
      errorsHumanReadable = `${errors.message}`
  }
  if (errors?.error === 'Internal Server Error' && errors?.errorType === 'TypeError') {
    errorsHumanReadable = 'shipping dimensions are missing'
  }
  return (
    <Tooltip disabled={!errorsHumanReadable} boundary="viewport" interactionKind={PopoverInteractionKind.HOVER}>
      <span className={CX({ 'bp3-tag bp3-minimal': true, [className]: className, 'bp3-large': large })}>
        {value === 'MODIFY_FAILED' ? (
          <>
            Listed <Icon icon="error" iconSize={12} style={{ marginLeft: 5 }} />
          </>
        ) : (
          title
        )}
      </span>
      {errorsHumanReadable && (
        <div style={{ maxWidth: 350, padding: 10 }}>
          <ListingErrors errors={errorsHumanReadable} />
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </div>
      )}
    </Tooltip>
  )
}

export default React.memo(NiceListingStatus)
